import { useDebouncedValue } from "@mantine/hooks";
import { useState } from "react";
import useSwr from "swr";

interface Options<T> {
  key: string;
  fetcher: (query: string) => Promise<T[]>;
  delay?: number;
  enabled?: boolean;
}

export function useDebouncedSearch<T>({ key, fetcher, delay = 800, enabled = true }: Options<T>) {
  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebouncedValue(query, delay);

  const { data = [], isLoading } = useSwr<T[]>(
    enabled ? `${key}:${JSON.stringify(debouncedQuery)}` : null,
    async () => fetcher(debouncedQuery ?? ""),
    { fallback: [] },
  );

  return { query, setQuery, data, isLoading };
}
